import { render } from "./BuyNowModal.vue?vue&type=template&id=27b4672a"
import script from "./BuyNowModal.vue?vue&type=script&lang=js"
export * from "./BuyNowModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__